<template>
  <div class="menu-main">
    <p class="menu-main__title coming__title text-gold">{{ $t('menu.coming-soon') }}</p>

    <div class="menu-main__list">
      <div class="menu-main__elem">
        <IconBase icon-name="IconFavorites">
          <IconSearch/>
        </IconBase>
        <span>{{ $t('menu.search') }}</span>
      </div>

      <div class="menu-main__elem">
        <IconBase icon-name="IconFavorites">
          <IconFavorites/>
        </IconBase>
        <span>{{ $t('menu.favorites') }}</span>
      </div>

      <div class="menu-main__elem">
        <IconBase icon-name="IconMessages">
          <IconMessages/>
        </IconBase>
        <span>{{ $t('menu.messages') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import IconBase from '@/components/Global/DynamicIcons/IconBase'
import IconSearch from '@/components/Global/DynamicIcons/icons/search'
import IconFavorites from '@/components/Global/DynamicIcons/icons/favorites'
import IconMessages from '@/components/Global/DynamicIcons/icons/messages'

export default {
  name: 'Support',

  components: {
    IconBase,
    IconSearch,
    IconFavorites,
    IconMessages,
  },
}
</script>


<style lang="scss" scoped>

</style>
